export enum CallTimeRange {
    BELOW_30S = '<30',
    BETWEEN_30S_AND_60S = '30-60',
    BETWEEN_61_AND_180S = '61-180',
    BETWEEN_181S_AND_300S = '181-300',
    BETWEEN_301S_AND_480S = '301-480',
    BETWEEN_481S_AND_600S = '481-600',
    ABOVE_600 = '>600',
}
